/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Info_Line_1Inputs */

const es_components_buy_messages_modal_info_line_1 = /** @type {(inputs: Components_Buy_Messages_Modal_Info_Line_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los mensajes se acreditan automáticamente en tu cuenta una vez confirmada la compra. Podrás ver el consumo en tu factura en la sección de Panel de Administrador -> Facturación.`)
};

const en_components_buy_messages_modal_info_line_1 = /** @type {(inputs: Components_Buy_Messages_Modal_Info_Line_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages are credited automatically to your account once the purchase is confirmed. You will be able to see the usage on your invoice in the section Administrator Panel → Billing.`)
};

/**
* | output |
* | --- |
* | "Messages are credited automatically to your account once the purchase is confirmed. You will be able to see the usage on your invoice in the section Administ..." |
*
* @param {Components_Buy_Messages_Modal_Info_Line_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_info_line_1 = /** @type {((inputs?: Components_Buy_Messages_Modal_Info_Line_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Info_Line_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_info_line_1(inputs)
	return en_components_buy_messages_modal_info_line_1(inputs)
});
export { components_buy_messages_modal_info_line_1 as "components.buy_messages_modal.info.line_1" }